/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_route_details__expense_note_section__date = /** @type {(inputs: {}) => string} */ () => {
	return `Datum`
};

const en_route_details__expense_note_section__date = /** @type {(inputs: {}) => string} */ () => {
	return `Date`
};

const es_route_details__expense_note_section__date = /** @type {(inputs: {}) => string} */ () => {
	return `Fecha`
};

const fr_route_details__expense_note_section__date = /** @type {(inputs: {}) => string} */ () => {
	return `Date`
};

const it_route_details__expense_note_section__date = /** @type {(inputs: {}) => string} */ () => {
	return `Data`
};

const nl_route_details__expense_note_section__date = /** @type {(inputs: {}) => string} */ () => {
	return `Datum`
};

const pt_route_details__expense_note_section__date = /** @type {(inputs: {}) => string} */ () => {
	return `Data`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__date = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.route_details__expense_note_section__date(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("route_details__expense_note_section__date", locale)
	if (locale === "de") return de_route_details__expense_note_section__date(inputs)
	if (locale === "en") return en_route_details__expense_note_section__date(inputs)
	if (locale === "es") return es_route_details__expense_note_section__date(inputs)
	if (locale === "fr") return fr_route_details__expense_note_section__date(inputs)
	if (locale === "it") return it_route_details__expense_note_section__date(inputs)
	if (locale === "nl") return nl_route_details__expense_note_section__date(inputs)
	return pt_route_details__expense_note_section__date(inputs)
};